export {
  V2GetStaticProps as getStaticProps,
  CarReviewsHubFeature as default,
} from '@cinch-nx/landing-feature-car-reviews-hub'
